import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { Map as LeafletMap } from 'leaflet';

type MapRefSetterProps = {
  onMapReady: (map: LeafletMap) => void;
};

export const MapRefSetter = ({ onMapReady }: MapRefSetterProps) => {
  const map = useMap();
  const mapRef = useRef<LeafletMap | null>(null);

  useEffect(() => {
    if (map && mapRef.current !== map) {
      mapRef.current = map;
      onMapReady(map);
    }
  }, [map, onMapReady]);

  return null;
};
